import { render } from "./DamageProductManagement.vue?vue&type=template&id=664c25b8&scoped=true"
import script from "./DamageProductManagement.vue?vue&type=script&lang=js"
export * from "./DamageProductManagement.vue?vue&type=script&lang=js"

import "./DamageProductManagement.vue?vue&type=style&index=0&id=664c25b8&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664c25b8"]])

export default __exports__